import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumberToFixedPdf as formatNumberToFixed } from 'utils';
import { View, Text } from '@react-pdf/renderer';
import PdfGlassConfigTotalCell from './PdfGlassConfigTotalCell';

import styles from '../styles';

const rowStyles = {
	...styles.glassConfigTableRow,
	...styles.glassConfigTableRowTotalMod,
};

const labelStyles = {
	...styles.glassConfigTableCellTitle,
	...styles.glassConfigTableCellTitleColor1,
};

const PdfGlassConfigTotal = ({
	quantity,
	m2,
	linearMeter,
	kg,
	prices,
	showPrice,
	priceVolumeCat,
	hasAllPrices,
}) => {
	const { t } = useTranslation('configurationTableHeading');

	return (
		<View style={rowStyles} wrap={false}>
			<View
				style={{ ...styles.glassConfigTableTotalCell, ...styles.glassConfigTableTotalCellFirst }}
			>
				<Text style={labelStyles}>{t('totalGlassType')}</Text>
			</View>
			<PdfGlassConfigTotalCell
				label={t('quantity')}
				value={formatNumberToFixed(quantity, 0, t('i18n:numberFormat'))}
			/>
			<PdfGlassConfigTotalCell
				label={
					<View>
						<Text>m²</Text>
					</View>
				}
				value={formatNumberToFixed(m2, 2, t('i18n:numberFormat'))}
			/>
			<PdfGlassConfigTotalCell
				label={t('linearMeterAbbrev')}
				value={formatNumberToFixed(linearMeter, 2, t('i18n:numberFormat'))}
			/>
			<PdfGlassConfigTotalCell
				label={t('kg')}
				value={formatNumberToFixed(kg, 0, t('i18n:numberFormat'))}
			/>
			{showPrice && (
				<PdfGlassConfigTotalCell
					label={t('price')}
					value={
						hasAllPrices
							? formatNumberToFixed(prices?.[priceVolumeCat], 2, t('i18n:numberFormat'))
							: '-'
					}
				/>
			)}
		</View>
	);
};

export default PdfGlassConfigTotal;
